/** Bepaalt de schooldag in Amsterdam, onafhankelijk van de apparaatinstellingen. */
export function bepaalToonDag(now: Date, dagWisselTijd = '16:30'): string {
  const delen = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }).formatToParts(now);
  const deel = (naam: string) => delen.find((d) => d.type === naam)!.value;
  const datum = new Date(`${deel('year')}-${deel('month')}-${deel('day')}T00:00:00Z`);
  const weekend = () => datum.getUTCDay() === 0 || datum.getUTCDay() === 6;
  if (weekend() || `${deel('hour')}:${deel('minute')}` >= dagWisselTijd) {
    do { datum.setUTCDate(datum.getUTCDate() + 1); } while (weekend());
  }
  return datum.toISOString().slice(0, 10);
}

/** Fixed 08:30 Amsterdam on TESTDATUM, including winter/summer offset. */
export function schoolNu(testdatum: string | null | undefined, now = new Date()): Date {
  if (!testdatum) return now;
  const probe = new Date(`${testdatum}T08:30:00Z`);
  const hour = Number(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', hour: '2-digit', hourCycle: 'h23' }).format(probe));
  return new Date(probe.getTime() - (hour - 8) * 3600000);
}
